module.exports = __webpack_public_path__ + "static/media/kuldetesunk.85bf412c.png";